if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.hydreraBilder();
        this.showActiveMedia();
      }

      /* Bilderna i zoomen ligger i data-srcset/data-src (se
         snippets/product-media.liquid) sa att de inte hamtas vid sidladdning.
         Har flyttas de over till riktiga attribut. Kors vid varje oppning men
         gor jobbet bara en gang per bild - attributen tas bort efterat. */
      hydreraBilder() {
        this.querySelectorAll('img[data-srcset], img[data-src]').forEach((bild) => {
          if (bild.dataset.srcset) {
            bild.srcset = bild.dataset.srcset;
            delete bild.dataset.srcset;
          }
          if (bild.dataset.src) {
            bild.src = bild.dataset.src;
            delete bild.dataset.src;
          }
        });
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
